import { oc } from '@orpc/contract';
import type { ContractMetadata } from './contract-metadata';

export const TERRA_ORPC_ROUTE_METADATA_KEY = 'terraOrpcRouteMetadata';

/**
 * Common error codes every Terra procedure may throw from its handler.
 * Handlers surface these via `throw errors.<CODE>({ data })`; the Nest oRPC
 * module maps them to the legacy `{ status, message, errors }` envelope.
 * Error data is intentionally left unschematized to keep the inferred router
 * types small on large contracts (see TS7056).
 */
export const terraContract = oc.$meta<ContractMetadata>({}).errors({
  BAD_REQUEST: {},
  UNAUTHORIZED: {},
  FORBIDDEN: {},
  NOT_FOUND: {},
  CONFLICT: {},
  UNPROCESSABLE_CONTENT: {},
  INTERNAL_SERVER_ERROR: {},
});
